import React, { createContext, useContext, useState } from "react";

const WartaContext = createContext();

export const WartaProvider = ({ children }) => {
  const [cartData, setCartData] = useState([]);
  const [checkoutArray, setCheckoutArray] = useState([]);
  const [inbox, setInbox] = useState([]);
  return (
    <WartaContext.Provider
      value={{
        cartData,
        setCartData,
        checkoutArray,
        setCheckoutArray,
        inbox,
        setInbox,
      }}
    >
      {children}
    </WartaContext.Provider>
  );
};

// Custom hook to use the context
export const useWarta = () => useContext(WartaContext);
